import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { serverSideProps } from '~/utils/ssr'
import { initialConversationUUID } from './utils'

type SliceState = {
  messages: Record<string, Message[]>
}

function buildInitialState(): SliceState {
  const uuid = initialConversationUUID()
  return {
    messages: { [uuid]: serverSideProps.inline_messages || [] }
  }
}

const inlineChatSlice = createSlice({
  name: 'inlineChat',
  initialState: buildInitialState(),
  reducers: {
    setInlineMessages(state, action: PayloadAction<{ uuid: string; messages: Message[] }>) {
      const { uuid, messages } = action.payload
      state.messages[uuid] = messages
    },
    appendInlineMessage(state, action: PayloadAction<{ uuid: string; message: Message }>) {
      const { message, uuid } = action.payload
      if (!state.messages[uuid]) {
        state.messages[uuid] = []
      }
      state.messages[uuid].push(message)
    },
    updateLatestInlineMessage(state, action: PayloadAction<{ uuid: string; message: Message }>) {
      const { uuid, message } = action.payload
      const messages = state.messages[uuid] || []
      const lastestMessage = messages[messages.length - 1]
      if (lastestMessage) {
        lastestMessage.role = message.role
        lastestMessage.text = message.text
        lastestMessage.blocks = message.blocks
      }
    },
    popInlineMessages(state, action: PayloadAction<{ uuid: string; count: number | undefined }>) {
      const { uuid, count = 1 } = action.payload
      const messages = state.messages[uuid] || []
      for (let i = 0; i < count; i++) {
        messages.pop()
      }
    }
  }
})

export const {
  appendInlineMessage,
  updateLatestInlineMessage,
  popInlineMessages,
  setInlineMessages
} = inlineChatSlice.actions

export default inlineChatSlice.reducer
